import React, { FC } from 'react';

import { IComponent } from '../../../typings/generic-component';
import { RaceSessionType, freePractices } from '../../../typings/race-session';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import { getSessionLabels } from '../../../utils/motorsports';
import { dateFormat } from '../../../utils/times';
import './lgp-preview.scss';
import StaticLinksContainer from '../../molecules/static-links-container/static-links-container';

export interface ILGPPreview extends IComponent {
  gpName: string;
  sessions: {
    sessionName: RaceSessionType;
    date: string;
  }[];
  links: { text: string; link: string }[];
}

const classNames = (): IClassNames =>
  makeClassNames({
    lgpPreview: 'lgp-preview',
    lgpPreviewHr: 'lgp-preview__hr',
    lgpPreviewH1: 'lgp-preview__h1',
    lgpPreviewH2: 'lgp-preview__h2',
    ctaContainer: 'cta-container',
  });

const cn = classNames();

const labels = getSessionLabels();

const LGPPreview: FC<ILGPPreview> = ({ gpName, sessions, links }) => {
  return (
    <div className={cn.lgpPreview}>
      <h1 className={cn.lgpPreviewH1}>Preview GP: {gpName}</h1>
      Il <b>{gpName}</b> è uno degli appuntamenti più attesi della stagione di Formula 1, con piloti e team che si
      preparano a sfidarsi su uno dei circuiti più caratteristici del calendario. Questo weekend di gara promette grande
      spettacolo, con numerosi elementi tecnici e strategici che influenzeranno l’esito finale. Ecco tutto ciò che c’è
      da sapere su <b>orari</b>, <b>classifiche</b>, <b>calendario</b>, <b>qualifiche</b>, <b>griglia di partenza</b>,{' '}
      <b>risultati</b>, <b>prove libere</b> e <b>dove seguire la gara</b> in diretta.
      <hr className={cn.lgpPreviewHr} />
      <h2 className={cn.lgpPreviewH2}>Programma del weekend: orari e prove libere</h2>
      Il weekend del <b>{gpName}</b> segue il consueto schema, con le sessioni di <b>prove libere</b>, <b>qualifiche</b>{' '}
      e la <b>gara</b> che si svolgeranno secondo i seguenti orari (fuso orario locale):
      <ul>
        {sessions?.map(({ sessionName, date }) => (
          <li key={date}>
            <b>
              {freePractices.includes(sessionName) ? 'Prove ' : ''}
              {labels[sessionName]}
            </b>
            : {dateFormat({ date, format: 'HH:mm' })}
          </li>
        ))}
      </ul>
      Puoi seguire tutte le sessioni in diretta su <b>Sky Sport F1</b>, il canale dedicato che ti porta nel cuore
      dell&apos;azione con commenti esperti, analisi dettagliate e interviste esclusive.
      <StaticLinksContainer links={links} />
    </div>
  );
};

export default LGPPreview;
